import React from 'react'
import { motion } from 'framer-motion' // Import Motion
import Digital from '../../assets/digital.jpg';
import Lang from '../../assets/lang.jpg';
import Strategy from '../../assets/strategy.jpg';
import Tools from '../../assets/tools.jpg';

const ToolKit = () => {
    // Parent container animation logic
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Delay between each card
                duration: 2 // Total section fade duration
            }
        }
    };

    // Individual item animation logic
    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { duration: 2, ease: "easeOut" } // 2 second duration as requested
        }
    };

    return (
        <section className="toolkit">
            <motion.div 
                className="container h"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
                variants={containerVariants}
            >
                <motion.h2 className="h2-dark center" variants={itemVariants}>
                    Precision: Conduits to code
                </motion.h2>
                <div className="divider">
                    <div className="v-primary vider"></div>
                    <div className="v-dark vider"></div>
                    <div className="v-primary vider"></div>
                </div>
                <div className="wrapper shadow">
                    <div className="description">
                        <motion.p className="text-dark text-center" variants={itemVariants}>
                            Explore the "Four Worlds" of my expertise:
                        </motion.p>
                        
                        <div className="cards">
                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Digital} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-text-dark">
                                    Digital Architecture (Web Development & Design)
                                </h3>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Tools} alt='Technical engineering' className='card-image'/>
                                </div>
                                <h3 className="card-text-dark">
                                    Technical Engineering (Power Tools & Field Operations)
                                </h3>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Strategy} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-text-dark">
                                    Professional Delivery Method (Retail & Wholesale)
                                </h3>
                            </motion.div>

                            <motion.div className="card" variants={itemVariants}>
                                <div className="card-image-container">
                                    <img src={Lang} alt='Digital design' className='card-image'/>
                                </div>
                                <h3 className="card-text-dark">
                                    Adaptive Verbal Exchange (Multilingualism)
                                </h3>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </motion.div>
        </section>
    )
}

export default ToolKit